import { Spinner } from '@nextui-org/react';
import React from 'react';

import ListUsecase from '@/app/template/ListUsecase';
import useListLayout from '@/components/list-layout/useListLayout';
import NoData from '@/components/NoData';
import RenderWhen from '@/components/RenderWhen';

import useBookMarkProfile from './useBookMarkProfile';

const BookMark: React.FC<{}> = () => {
  const { type: typeLayout } = useListLayout();
  const { currentPage, artworks, loading, loadMore } = useBookMarkProfile();

  const [openFilter, setOpenFilter] = React.useState(false);

  return (
    <div>
      <RenderWhen>
        <RenderWhen.If isTrue={typeLayout === 'col'}>
          <RenderWhen.If isTrue={loading && artworks.length === 0}>
            <div className="flex min-h-[400px] items-center justify-center">
              <Spinner label="loading..." />
            </div>
          </RenderWhen.If>
          <RenderWhen.If isTrue={artworks.length === 0 && !loading}>
            <NoData />
          </RenderWhen.If>
          <RenderWhen.If isTrue={artworks.length > 0}>
            <div>
              <ListUsecase
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
                list={artworks}
                loadMore={loadMore}
                currentPage={currentPage}
                // getUseCaseURL={getUseCaseURL}
                loading={loading}
              />
            </div>
          </RenderWhen.If>
        </RenderWhen.If>
      </RenderWhen>
    </div>
  );
};

export default BookMark;
